import { axiosInstance as axios } from 'helpers/axiosInstance';

// https://swr.vercel.app/docs/data-fetching#axios
export const swrAxiosGetFetcher = (url) => axios.get(url).then((res) => res.data);

export const elasticSearchFetcher = (params) => axios.post('/api/indexSearch', params).then((res) => res.data);
